import EmailCitationButton from '../../../../common/components/documentViewer/emailCitationButton';
import { IOrderViewerMainStore } from '../../typing/stores';
import { inject } from 'mobx-react';

export default inject((stores: IOrderViewerMainStore) => ({
	...stores.orderViewerStore.viewModel.headerModel.citationEmail
}))(EmailCitationButton);
